import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { createElement, Fragment, cloneElement } from 'react';
import { useTooltipState, TooltipReference, Tooltip as Tooltip$1, TooltipArrow } from 'reakit/Tooltip';

var _excluded = ["title", "placement", "children"];
var Tooltip = function Tooltip(props) {
  var title = props.title,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom' : _props$placement,
      children = props.children,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var tooltip = useTooltipState({
    placement: placement,
    animated: 50
  });
  return createElement(Fragment, null, createElement(TooltipReference, Object.assign({}, tooltip, {
    ref: children.ref
  }, children.props), function (referenceProps) {
    var handleClick = function handleClick(event) {
      event.persist();
      tooltip.hide();

      if (referenceProps.onClick) {
        referenceProps.onClick(event);
      }
    };

    return cloneElement(children, _extends({}, referenceProps, {
      onClick: handleClick,
      tabIndex: children.props.tabIndex
    }));
  }), tooltip.visible && createElement(Tooltip$1, Object.assign({}, tooltip, otherProps, {
    className: "yt-tooltip-container"
  }), createElement("div", {
    className: "yt-tooltip"
  }, createElement(TooltipArrow, Object.assign({
    className: "yt-tooltip-arrow"
  }, tooltip)), title)));
};

export { Tooltip };
//# sourceMappingURL=Tooltip.js.map
